export default __webpack_public_path__ + "static/chart_realworld-938302b0c32a4561478bebe7a1909018.svg";